import { render, staticRenderFns } from "./RoomStatusDetailCustomerTab.vue?vue&type=template&id=fb34c26a"
import script from "./RoomStatusDetailCustomerTab.vue?vue&type=script&lang=js"
export * from "./RoomStatusDetailCustomerTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports